import {  useQuery } from "react-query"
import DataService from "../../../config/DataServices"
import StakeService from "../../../config/StakeServices";
const { getRequest } = DataService();
const { getStakeRequest } = StakeService();

export const useUserLoginHistory = ({ page, size }) => {

    return useQuery({
        queryKey: ['userlogin-history',page, size],
        queryFn: () => {
            return getRequest(`user/auth/userLoginHistory?page=${page}&size=${size}`)
        },
    })
}



export const useUserGetRank = () => {

    return useQuery({
        queryKey: ['user-rank'],
        queryFn: () => {
            return getRequest(`user/auth/get-userRank`)
        },
    })
}
export const useGetRankDetails = () => {

    return useQuery({
        queryKey: ['rank-details'],
        queryFn: () => {
            return getRequest(`user/auth/rank-details`)
        },
    })
}
// api/v1/user/auth/getGlobaldividedHis?page=0&size=10
export const useGetRankHistory = ({ page, size,rank }) => {

    return useQuery({
        queryKey: ['rank-history',page, size,rank],
        queryFn: () => {
            return getRequest(`user/auth/getGlobaldividedHis?page=${page}&size=${size}&rank=${rank}`)
        },
    })
}
// co-partner list
export const useGetCopartnerList = () => {

    return useQuery({
        queryKey: ['get-coPartner'],
        queryFn: () => {
            return getStakeRequest(`user/stake/getClub`)
        },
    })
}


export const useGetClubActiveStatus = () => {

    return useQuery({
        queryKey: ['clubeActiveStatus'],
        queryFn: () => {
            return getStakeRequest(`user/stake/getSlotCount`)
        },
    })
}